
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/integrations",
      function () {
        return require("private-next-pages/integrations.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/integrations"])
      });
    }
  